import React, { Component } from 'react';
// import Formsy from 'formsy-react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import Formsy from 'formsy-react';
import styled from 'styled-components';
import {
  UnderlinedInput,
  UnderlinedTextarea,
  StyledToggle,
  FileInput,
  BorderedSelect,
} from '../../Formsy';
import Styles from './ProjectForm.styles';
import { Button } from '../../../components/UIKit';
import ProjectFormGroupTitle from './ProjectFormGroupTitle';
import ProjectFormFieldGroup from './ProjectFormFieldGroup';

const Section = styled.div`
  background: white;
  padding: 15px;
  flex: 1 1 0%;
  display: flex;
  flex-direction: column;
  flex-basis: 20%;
`;

const SettingWrapper = styled.div``;

const SettingLabel = styled.div`
  padding: 10px 0;
`;

const SettingContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const SettingOption = styled.span`
  margin: 0 20px;
`;

const Filler = styled.div`
  flex: 1;
`;

class ProjectForm extends Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.onReset = this.onReset.bind(this);
    this.state = {
      canSubmit: false,
    };
  }

  onReset(fields) {
    const model = this.form.getModel();
    this.form.reset({ ...model, ...fields });
  }

  getModel() {
    return this.form.getModel();
  }

  submit(model) {
    this.props.onSubmit(model);
  }

  render() {
    const popupStyle = this.props.inPopup ? { flex: 1, width: '100%' } : { width: '60%' };
    // const { favicon: { downloadURL = '' }, branding_logo: { brandingLogoDownloadUrl = '' } = {} } = this.props.data;

    return (
      <div
        style={{
          display: 'flex',
          minWidth: '800px',
          minHeight: '800px',
          flex: 1,
        }}
      >
        <Formsy
          ref={(c) => {
            this.form = c;
          }}
          onValidSubmit={this.submit}
          style={Styles.formStyle}
        >
          <div style={[Styles.fieldsContainer, popupStyle]}>
            <div style={Styles.leftColumn}>
              <div style={Styles.leftColumnInner}>
                <div style={Styles.tiles.projectDescription}>
                  <div style={Styles.columnContent}>
                    <div>
                      <UnderlinedInput
                        name="name"
                        placeholder="Project name"
                        required
                        value={this.props.data.name || null}
                        validations={{
                          maxLength: 50,
                        }}
                        validationErrors={{
                          maxLength: 'You can not type in more than 50 characters',
                        }}
                      />
                    </div>
                    <div style={Styles.descriptionWrapper}>
                      <ProjectFormFieldGroup title={'Description'} onReset={this.onReset} fill>
                        <UnderlinedTextarea
                          name="description"
                          value={this.props.data.description || null}
                          validations={{
                            maxLength: 250,
                          }}
                          validationErrors={{
                            maxLength: 'You can not type in more than 250 characters',
                          }}
                        />
                      </ProjectFormFieldGroup>
                    </div>
                  </div>
                </div>
                <div style={Styles.tiles.projectPrivacy}>
                  <div style={Styles.columnContent}>
                    <ProjectFormGroupTitle showIcon={false}>Privacy</ProjectFormGroupTitle>
                    <div style={Styles.switcherBoxWrapper}>
                      <div style={Styles.switcherWrapper}>
                        <span>Public</span>
                        <StyledToggle name="private" value="false" />
                        <span>Private</span>
                      </div>
                      <div style={Styles.switcherUrlWrapper}>
                        <span> jumpr.com/34dh6/</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={Styles.tiles.projectPrivacy}>
                  <div style={Styles.columnContent}>
                    <ProjectFormGroupTitle showIcon={false}>Project defaults</ProjectFormGroupTitle>
                    <span>Default camera phi</span>
                    <div style={[Styles.columnContent, { padding: '15px 0' }]}>
                      <div>
                        <UnderlinedInput
                          name="camera_defaults_phi"
                          placeholder="Default camera phi"
                          required
                          value={this.props.data.camera_defaults_phi || -10}
                          validations={{
                            isNumeric: true,
                          }}
                          validationErrors={{
                            isNumeric: 'Podana wartość musi być liczbą',
                          }}
                        />
                      </div>
                    </div>
                    <span>Default camera theta</span>
                    <div style={[Styles.columnContent, { padding: '15px 0' }]}>
                      <div>
                        <UnderlinedInput
                          name="camera_defaults_theta"
                          placeholder="Default camera theta"
                          required
                          value={this.props.data.camera_defaults_theta || 30}
                          validations={{
                            isNumeric: true,
                          }}
                          validationErrors={{
                            isNumeric: 'Podana wartość musi być liczbą',
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <Section>
                  <ProjectFormGroupTitle showIcon={false}>Project Branding</ProjectFormGroupTitle>
                  <SettingWrapper>
                    <SettingLabel>Toolbar mode</SettingLabel>
                    <SettingContent>
                      <BorderedSelect
                        placeholder="Toolbar Mode"
                        name="toolbarMode"
                        options={[
                          { title: 'visible', value: 'visible' },
                          { title: 'hidden', value: 'hidden' },
                        ]}
                        value={this.props.data.toolbarMode || 'visible'}
                        style={{ width: 300 }}
                      />
                      <Filler />
                    </SettingContent>
                    <div style={[Styles.columnContent, { padding: '15px 0' }]}>
                      <ProjectFormFieldGroup title={'Favicon'} onReset={this.onReset} fill>
                        <FileInput name="favicon" style={Styles.favicon} imageUrl={this.props.data.favicon ? this.props.data.favicon.downloadURL : ''} />
                      </ProjectFormFieldGroup>
                    </div>
                    <div style={[Styles.columnContent, { padding: '15px 0' }]}>
                      <div>
                        <UnderlinedInput
                          name="color"
                          placeholder="Project color"
                          required
                          value={this.props.data.color || '#000000'}
                          validations={{
                            maxLength: 50,
                          }}
                          validationErrors={{
                            maxLength: 'You can not type in more than 50 characters',
                          }}
                        />
                      </div>
                    </div>
                    <div style={[Styles.columnContent, { padding: '15px 0' }]}>
                      <div>
                        <label>Hotspot color</label>
                        <UnderlinedInput
                          name="hotspots_color"
                          placeholder="Hotspots color"
                          required
                          value={this.props.data.hotspots_color || '#ffffff'}
                          validations={{
                            maxLength: 50,
                          }}
                          validationErrors={{
                            maxLength: 'You can not type in more than 50 characters',
                          }}
                        />
                      </div>
                    </div>
                    <div style={[Styles.columnContent, { padding: '15px 0' }]}>
                      <ProjectFormFieldGroup title={'branding logo'} onReset={this.onReset} fill>
                        <FileInput name="branding_logo" style={Styles.favicon} imageUrl={this.props.data.branding_logo ? this.props.data.branding_logo.downloadURL : ''} />
                      </ProjectFormFieldGroup>
                    </div>
                  </SettingWrapper>
                </Section>
                <div style={Styles.tiles.projectTypography}>
                  {/* <div style={[Styles.columnContent, { justifyContent: 'space-evenly' }]}>
                    <ProjectFormFieldGroup
                      title={'Typography'}
                      onReset={this.onReset}
                      fill
                      containerStyle={{
                        flexDirection: 'column',
                        justifyContent: 'space-evenly',
                      }}
                    >
                      <BorderedSelect
                        placeholder="Header font[ARIAL BLACK]"
                        name="font"
                        options={[
                          { title: 'test', value: 'test' },
                          { title: 'test2', value: 'test2' },
                          { title: 'test3', value: 'test3' },
                        ]}
                        value={this.props.data.font || null}
                      />
                      <BorderedSelect
                        name="body_text"
                        placeholder="Body text font[ARIAL]"
                        options={[
                          { title: 'test', value: 'test' },
                          { title: 'test2', value: 'test2' },
                          { title: 'test3', value: 'test3' },
                        ]}
                        value={this.props.data.body_text || null}
                      />
                    </ProjectFormFieldGroup>
                  </div> */}
                </div>
              </div>
            </div>
            <div style={Styles.rightColumn}>
              <div style={Styles.columnContent}>
                <div>
                  <ProjectFormFieldGroup
                    title={'Synchronizacja z bazą produktów'}
                    onReset={this.onReset}
                  >
                    <UnderlinedInput
                      name="url"
                      placeholder="adres url"
                      value={this.props.data.url || null}
                    />
                    <UnderlinedInput
                      name="token"
                      placeholder="token"
                      value={this.props.data.token || null}
                    />
                    <UnderlinedInput
                      name="condition"
                      placeholder="warunek statusu"
                      value={this.props.data.condition || null}
                    />
                  </ProjectFormFieldGroup>
                  <Button type="none" style={Styles.testConnectionButton}>
                    Test connection
                  </Button>
                </div>
                <div />
              </div>
            </div>
          </div>
          {!this.props.inPopup && (
            <div style={Styles.submitBarWrapper}>
              <div style={Styles.submitBarInner}>
                <div style={[Styles.leftColumnInner, { justifyContent: 'flex-end' }]}>
                  <div style={Styles.cancelButtonWrapper}>
                    <Button
                      type="none"
                      style={Styles.cancelButton}
                      onClick={this.props.history.goBack}
                    >
                      <span style={{ color: '#ccc' }}>Cancel</span>
                    </Button>
                  </div>
                </div>
                <div style={[Styles.rightColumn, { justifyContent: 'flex-start' }]}>
                  <div style={Styles.submitButtonWrapper}>
                    <Button type="none" style={Styles.submitButton}>
                      <span style={{ color: 'rgb(72,97,102)' }}> Add to projects</span>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Formsy>
      </div>
    );
  }
}
ProjectForm.defaultProps = {
  inPopup: false,
  data: {
    name: '',
    favicon: '',
    branding_logo: '',
    description: '',
    font: '',
    body_text: '',
    url: '',
    token: '',
    condition: '',
  },
};

ProjectForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  inPopup: PropTypes.bool,
  data: PropTypes.shape({
    name: PropTypes.string,
    favicon: PropTypes.string,
    branding_logo: PropTypes.string,
    description: PropTypes.string,
    font: PropTypes.string,
    body_text: PropTypes.string,
    url: PropTypes.string,
    token: PropTypes.string,
    condition: PropTypes.string,
  }),
};

export default Radium(ProjectForm);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectForm/ProjectForm.js